var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTicketSeller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2.0332,
    r: 1.5,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 2.0332,
    r: 1.5,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 2.0332,
    r: 1.5,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 2.0332,
    r: 1.5,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 6.5332,
    r: 1.5,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5332,
    r: 1.5,
    fill: "currentColor"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 6.5332,
    r: 1.5,
    fill: "currentColor"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 6.5332,
    r: 1.5,
    fill: "currentColor"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 11.0332,
    r: 1.5,
    fill: "currentColor"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 11.0332,
    r: 1.5,
    fill: "currentColor"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.0332,
    r: 1.5,
    fill: "currentColor"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 11.0332,
    r: 1.5,
    fill: "currentColor"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 15.5332,
    r: 1.5,
    fill: "currentColor"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 15.5332,
    r: 1.5,
    fill: "currentColor"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 15.5332,
    r: 1.5,
    fill: "currentColor"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5332,
    r: 1.5,
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSeller);
export default __webpack_public_path__ + "static/media/ticket-seller.ea9d6b8f204dca0f51d3f7323d3faad2.svg";
export { ForwardRef as ReactComponent };